// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu8/Item.css
// module id = 2040
// module chunks = 0